<div class="modal-content bg-color">
  <div>
    <span class="top-left-title-bar">Error Report</span>

  </div>
  <div class="modal-body modal-message-body">



    <div>
      <div style="color: #808080">Following {{requestType}}(s) was failed to upload  </div>
      <br>

      <div class="main-table m-datatable m-datatable--default m-datatable--loaded w-100" id='errorTable' #errorTable>

        <table class="box-padding full-width table-fixed table-shade">
          <thead>
          <tr class="tr-header">

            <th class="tr-header pl-2">{{(requestType == 'insight'?'Account Number':requestType)}}</th>
            <th class="tr-header pl-2">Reason</th>

          </tr>
          </thead>
          <tr *ngFor="let err of errorList; let i = index;"
              [className]="i % 2 ==0 ? 'tr-height td-style-2 k-cursor-pointer card-color-even tr-height'
        : 'tr-height td-style-2 k-cursor-pointer card-color-odd tr-height'">

            <td class="pl-2">{{err.provided_number}}</td>
            <td class="pl-2">{{err.invalid_reason}}</td>

          </tr>
        </table>
      </div>



    </div>


  </div>
  <div class="modal-footer row justify-content-end" style="border:none; margin-top:-20px">
    <button type="button" class="cancel-button" (click)="close()">
      Close
    </button>
    <button
      class="add-btn"  (click)="downloadErrorReport()" >
      Download Error Report
    </button>

  </div>
</div>
